import { useState, useEffect, useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { UserType, useUser } from "./useUser";

export const useAuth = () => {

	const { addUser, removeUser, user, token, role, roles, userId } = useUser(); //prueba
	console.log("user en useAuth.js", user)
	console.log("role en useAuth.js", role)
	console.log("userId en useAuth.js", userId)

	const [isAuthenticated, setIsAuthenticated] = useState(false);
	console.log(isAuthenticated)

	useEffect(() => {
		if (user) {
			setIsAuthenticated(true);
		} else {
			setIsAuthenticated(false);
		}
	}, [user]);

	// login
	// useCallback: identidad estable. Si login() se recreara en cada render,
	// authContext lo usa en los deps del useEffect y checkAuthenticated correría
	// cada render (re-hidratando la sesión tras el logout). Ver authContext.jsx.
	const login = useCallback((name, token, role, userId, roles) => {
		/* NOTE: this is where you would query the user from 
		  an auth provider like firebase, supabase or Auth0 
		  and retrieve the user object. Additionally you 
		  could do your own auth, but that is not recommended
	    
		  So What we'll do for now is set a mock user object.
		*/
		addUser(name, token, role, userId, roles); //multi-rol (074): recibe la lista
	}, [addUser]);

	const logout = useCallback(() => {
		removeUser();
	}, [removeUser]);

	return { user, login, logout, isAuthenticated, role, roles, userId, token };
};